import { TxnDetailWrapperProps } from '@bitte-ai/types';
import { Transaction } from '@near-wallet-selector/core';
import { formatCosts } from '../../../../lib/utils';
import { TxnContractDetails } from './TxnContractDetails';

export const TxnActionsDetails = ({
  accountId,
  transaction,
  modifiedUrl,
  showDetails,
  showTxnDetail,
  costs,
  gasPrice,
}: TxnDetailWrapperProps): JSX.Element => {
  return (
    <>
      {transaction.map((txn: Transaction, txnIdx: number) => {
        const txnData = {
          transaction: txn,
          showDetails,
          modifiedUrl,
          gasPrice,
          ...formatCosts(costs, gasPrice),
        };

        return (
          <TxnContractDetails
            accountId={accountId}
            key={txnIdx}
            data={txnData}
            showDetails={showTxnDetail}
            actions={txnData.transaction.actions}
          />
        );
      })}
    </>
  );
};
